import { DashboardMetricKey, StudioType } from "../../enums";
import { MetricConfig } from "../../../types/dashboard";
import styles from "./metricConfigs.module.scss";

// Studios with any of these types run a schedule, so reservation/class metrics apply.
// Sales/store metrics carry no `studioTypes` at all — they are universal, because every
// studio can sell products via the cashdesk regardless of its configured types.
const ACTIVITY_STUDIO_TYPES = [
  StudioType.Group,
  StudioType.Service,
  StudioType.Gym,
];

export const METRIC_CONFIGS: MetricConfig[] = [
  {
    key: DashboardMetricKey.UserReservations,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Потребителски резервации",
    icon: "📱",
    iconClass: styles.iconUsers,
    description:
      "Брой резервации направени от потребители чрез клиентския портал",
    hasDetail: true,
  },
  {
    key: DashboardMetricKey.AdminReservations,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Административни резервации",
    icon: "🏢",
    iconClass: styles.iconUsers,
    description:
      "Брой резервации направени от администратори чрез административния панел",
    hasDetail: true,
  },
  {
    key: DashboardMetricKey.UsersOnWaitingList,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Потребители, в списъка на изчакващи",
    icon: "⏳",
    iconClass: styles.iconUsers,
    description:
      "Брой потребители, които са в списъка на изчакващи за дадени събития",
    hasDetail: true,
  },
  {
    key: DashboardMetricKey.CancelledByUser,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Отказани от потребители",
    icon: "🚫",
    iconClass: styles.iconAlert,
    description:
      "Брой резервации отказани директно от потребители в избрания период",
    hasDetail: true,
  },
  {
    key: DashboardMetricKey.CancelledByAdmin,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Отказани от администратори",
    icon: "❌",
    iconClass: styles.iconAlert,
    description:
      "Брой резервации отказани от служители на обекта в избрания период",
    hasDetail: true,
  },
  {
    key: DashboardMetricKey.NoShowReservations,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Неявили се",
    icon: "👻",
    iconClass: styles.iconAlert,
    description: "Брой неявили се потребители за избрания период.",
    hasDetail: true,
  },
  {
    key: DashboardMetricKey.NoShowRate,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Процент неявили се",
    icon: "📊",
    iconClass: styles.iconPerformance,
    description:
      "Процент резервации, на които потребители не са се явили за избрания период. Формула на изчисляване: (Брой пропуснати резервации / Общ брой резервации × 100)",
    hasDetail: false,
  },
  {
    key: DashboardMetricKey.UnconfirmedReservations,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Непотвърдени резервации",
    icon: "❓",
    iconClass: styles.iconAlert,
    description:
      'Брой резервации със статус "Очаква потвърждение" за избрания период',
    hasDetail: true,
  },
  // {
  //   key: DashboardMetricKey.ConfirmedRevenue,
  //   title: "Потвърдени приходи",
  //   icon: "💰",
  //   iconClass: styles.iconRevenue,
  //   description: "Общи приходи от потвърдени резервации и продадени абонаменти",
  //   hasDetail: true,
  //   minRole: 15, // Manager+ only
  // },
  // {
  //   key: DashboardMetricKey.EventsCount,
  //   title: "Брой събития",
  //   icon: "📅",
  //   iconClass: styles.iconEvents,
  //   description:
  //     "Общ брой създадени събития (видими и скрити) в избрания период",
  //   hasDetail: true,
  // },
  {
    key: DashboardMetricKey.NewUserSignups,
    studioTypes: ACTIVITY_STUDIO_TYPES,
    title: "Нови потребители",
    icon: "🆕",
    iconClass: styles.iconUsers,
    description:
      "Брой нови потребители, които са били регистрирани за избрания период (включва и създадени от администратори потребители)",
    hasDetail: true,
  },
  // {
  //   key: DashboardMetricKey.ClassCapacityUtilization,
  //   title: "Използване на капацитета",
  //   icon: "📈",
  //   iconClass: styles.iconPerformance,
  //   description:
  //     "Средно използване на капацитета на класовете (явили се / общ капацитет × 100)",
  //   hasDetail: true,
  // },

  // {
  //   key: DashboardMetricKey.RevenueFromPlans,
  //   title: "Приходи от абонаменти",
  //   icon: "💳",
  //   iconClass: styles.iconRevenue,
  //   description: "Общи приходи от продадени абонаменти в избрания период",
  //   hasDetail: true,
  //   minRole: 15, // Manager+ only
  // },
  // {
  //   key: DashboardMetricKey.StaffCommission,
  //   title: "Комисионни на персонала",
  //   icon: "👥",
  //   iconClass: styles.iconRevenue,
  //   description:
  //     "Общи комисионни на инструкторите от продажби и проведени занимания",
  //   hasDetail: true,
  //   minRole: 15, // Manager+ only
  // },
  // {
  //   key: DashboardMetricKey.NewVsReturningUsersRatio,
  //   title: "Съотношение нови/връщащи се",
  //   icon: "🔄",
  //   iconClass: styles.iconUsers,
  //   description:
  //     "Съотношение между нови и връщащи се потребители (формат X.X:1)",
  //   hasDetail: false,
  // },
  // {
  //   key: DashboardMetricKey.AverageClassSize,
  //   title: "Средна големина на класа",
  //   icon: "👨‍👩‍👧‍👦",
  //   iconClass: styles.iconPerformance,
  //   description:
  //     "Средно количество участници в клас (явили се участници / брой класове)",
  //   hasDetail: false,
  // },
  // {
  //   key: DashboardMetricKey.ClassesTaught,
  //   title: "Проведени занимания",
  //   icon: "🎯",
  //   iconClass: styles.iconEvents,
  //   description: "Брой проведени занимания с поне един явил се участник",
  //   hasDetail: true,
  // },
  // {
  //   key: DashboardMetricKey.PeakHours,
  //   title: "Пикови часове",
  //   icon: "⏰",
  //   iconClass: styles.iconPerformance,
  //   description:
  //     "Най-активни часове на деня базирани на присъствието на потребители",
  //   hasDetail: true,
  // },
  // {
  //   key: DashboardMetricKey.MostPopularClasses,
  //   title: "Най-популярни класове",
  //   icon: "🌟",
  //   iconClass: styles.iconEvents,
  //   description: "Класове с най-високо присъствие и резервации",
  //   hasDetail: true,
  // },
  // {
  //   key: DashboardMetricKey.TotalActiveUsers,
  //   title: "Общо активни потребители",
  //   icon: "👤",
  //   iconClass: styles.iconUsers,
  //   description: "Уникални потребители с поне една резервация в периода",
  //   hasDetail: true,
  // },
  // {
  //   key: DashboardMetricKey.ExpiringPlans,
  //   title: "Изтичащи абонаменти",
  //   icon: "⚠️",
  //   iconClass: styles.iconAlert,
  //   description: "Абонаменти, които ще изтекат в следващите 7 дни",
  //   hasDetail: true,
  // },
  // {
  //   key: DashboardMetricKey.LowAttendanceClasses,
  //   title: 'Класове с ниско присъствие',
  //   icon: '📉',
  //   iconClass: styles.iconAlert,
  //   description: 'Класове с присъствие под 50% от капацитета',
  //   hasDetail: true,
  // },

  // ─── Store / Sales (Магазин) ───
  {
    key: DashboardMetricKey.StoreTurnover,
    title: "Оборот",
    icon: "💰",
    iconClass: styles.iconRevenue,
    description: "Общ оборот от продажби на каса за избрания период",
    hasDetail: false,
    minRole: 15, // Manager+ only
  },
  {
    key: DashboardMetricKey.StoreSalesCount,
    title: "Брой продажби",
    icon: "🛒",
    iconClass: styles.iconEvents,
    description: "Брой направени продажби (поръчки) на каса за избрания период",
    hasDetail: false,
  },
  {
    key: DashboardMetricKey.StoreGrossProfit,
    title: "Печалба",
    icon: "📈",
    iconClass: styles.iconRevenue,
    description:
      "Брутна печалба от продажби (оборот минус себестойност на продадените стоки) за избрания период",
    hasDetail: false,
    minRole: 15, // Manager+ only
  },
  {
    key: DashboardMetricKey.StoreAverageOrderValue,
    title: "Средна стойност на продажба",
    icon: "🧾",
    iconClass: styles.iconPerformance,
    description:
      "Среден оборот на една продажба (оборот / брой продажби) за избрания период",
    hasDetail: false,
  },
  {
    key: DashboardMetricKey.StoreTopProducts,
    title: "Най-продавани продукти",
    icon: "🏆",
    iconClass: styles.iconEvents,
    description: "Продуктите с най-много продадени бройки за избрания период",
    hasDetail: true,
    isTextValue: true,
  },
  {
    key: DashboardMetricKey.StoreLowStock,
    title: "Ниска наличност",
    icon: "📦",
    iconClass: styles.iconAlert,
    description: "Брой продукти, чиято наличност е под зададения праг",
    hasDetail: false,
  },
  {
    key: DashboardMetricKey.StoreExpiringProducts,
    title: "Продукти с изтичащ срок на годност",
    icon: "⏳",
    iconClass: styles.iconAlert,
    description:
      "Брой продукти с партиди, чийто срок на годност изтича до 10 дни или вече е изтекъл",
    hasDetail: false,
  },
];

export const getMetricConfig = (
  key: DashboardMetricKey,
): MetricConfig | undefined => {
  return METRIC_CONFIGS.find((config) => config.key === key);
};

/**
 * Whether a metric is relevant for a studio with the given types. Metrics
 * without a `studioTypes` restriction are universal; the rest require the
 * studio to have at least one matching type. A shop-only studio therefore hides
 * reservation/class metrics while still seeing the sales metrics.
 */
export const isMetricRelevantForStudioTypes = (
  metric: MetricConfig,
  studioTypes: StudioType[],
): boolean =>
  !metric.studioTypes ||
  metric.studioTypes.some((type) => studioTypes.includes(type));

export const getBasicMetricsConfigs = (): MetricConfig[] => {
  return METRIC_CONFIGS.filter((config) =>
    [
      DashboardMetricKey.CancelledByUser,
      DashboardMetricKey.CancelledByAdmin,
      DashboardMetricKey.UserReservations,
      DashboardMetricKey.AdminReservations,
      DashboardMetricKey.UsersOnWaitingList,
      DashboardMetricKey.NoShowReservations,
      DashboardMetricKey.UnconfirmedReservations,
      DashboardMetricKey.ConfirmedRevenue,
      DashboardMetricKey.EventsCount,
      DashboardMetricKey.NewUserSignups,
      DashboardMetricKey.NoShowRate,
      DashboardMetricKey.ClassCapacityUtilization,
    ].includes(config.key),
  );
};

export const getAnalyticsMetricsConfigs = (): MetricConfig[] => {
  return METRIC_CONFIGS.filter((config) =>
    [
      DashboardMetricKey.RevenueFromPlans,
      DashboardMetricKey.StaffCommission,
      DashboardMetricKey.NewVsReturningUsersRatio,
      DashboardMetricKey.AverageClassSize,
      DashboardMetricKey.ClassesTaught,
      DashboardMetricKey.PeakHours,
      DashboardMetricKey.MostPopularClasses,
      DashboardMetricKey.TotalActiveUsers,
      DashboardMetricKey.ExpiringPlans,
      DashboardMetricKey.LowAttendanceClasses,
    ].includes(config.key),
  );
};

export const canUserAccessMetric = (
  config: MetricConfig,
  userRole: number,
): boolean => {
  return !config.minRole || userRole >= config.minRole;
};

export const getMetricsForUserRole = (userRole: number): MetricConfig[] => {
  return METRIC_CONFIGS.filter((config) =>
    canUserAccessMetric(config, userRole),
  );
};
